import { render, staticRenderFns } from "./VatPreviewLoading.vue?vue&type=template&id=6e5993d8&scoped=true"
import script from "./VatPreviewLoading.vue?vue&type=script&lang=js"
export * from "./VatPreviewLoading.vue?vue&type=script&lang=js"
import style0 from "./VatPreviewLoading.vue?vue&type=style&index=0&id=6e5993d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5993d8",
  null
  
)

export default component.exports